import {
  Button,
  Container,
  // FormControlLabel,
  // IconButton,
  Paper,
  Grid
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useStyles } from './styles'
// import RotateLeftIcon from '@mui/icons-material/RotateLeft'
// import { AutoCompleter } from '../../../AutoCompleter/AutoCompleter'
import { usePosition } from '../../context'
import positionBusiness from '../../actions/positionBusiness'
import positionActions from '../../actions/positionActions'
import { useWarehouses, useZones } from '../../../../hooks'
import { SubZone, Zone } from '../../../../interfaces'
import { Selector } from '../../../Selector'
import { useSubZones } from '../../../../hooks/useSubZones'
import { AutoCompleterV2 } from '../../../AutoCompleterV2/AutoCompleterV2'
import { TypePositionsDDL } from '../../../TypePosition/TypePositionsDDL'
import { ActiveDDL } from '../../../PositionMassive/ActiveDLL'

interface SearchPositionProps {}

export const SearchPosition: React.FC<SearchPositionProps> = () => {
  const [zonesByWarehouse, setZonesByWarehouse] = useState<Zone[]>([])
  const [subzonesByWarehouse, setSubZonesByWarehouse] = useState<SubZone[]>([])

  const {
    zonesState: { zones },
    getZones
  } = useZones()

  const {
    warehousesState: { warehouses },
    getWarehouses
  } = useWarehouses()

  const {
    subzonesState: { subzones },
    getSubZones
  } = useSubZones()

  const { state, dispatch } = usePosition()
  const { loaderName, posiciones, busqueda, filters, firstEffect } = state
  const { handleBusqueda, fetchFilteredData, fetchDataGrid } =
    positionBusiness()

  const { setFirstEffect, setBusqueda } = positionActions()

  const classes = useStyles()

  useEffect(() => {
    if (warehouses?.length === 0) {
      getWarehouses()
    }
  }, [])

  useEffect(() => {
    if (zones?.length === 0) {
      getZones()
    }
  }, [])

  useEffect(() => {
    if (subzones?.length === 0) {
      getSubZones()
    }
  }, [])

  useEffect(() => {
    if (!firstEffect) {
      fetchDataGrid()
    } else {
      dispatch(setFirstEffect(false))
    }
  }, [filters])

  const handleSelectedWarehouseZones = (zones: Zone[]) => {
    if (busqueda.warehouseId > 0) {
      const initialZones = [...zones!]

      const filteredZones = initialZones.filter(
        (x: Zone) => x.warehouseId === busqueda.warehouseId
      )

      setZonesByWarehouse(filteredZones)

      if (
        filteredZones.filter((x) => x.zoneId === busqueda.zoneId).length === 0
      ) {
        dispatch(setBusqueda({ ...busqueda, ['zoneId']: -1 }))
      }
    } else {
      dispatch(setBusqueda({ ...busqueda, ['warehouseId']: -1 }))
      dispatch(setBusqueda({ ...busqueda, ['zoneId']: -1 }))
      setZonesByWarehouse([])
    }
  }

  const handleSelectedSubZones = (subzones: SubZone[]) => {
    if (busqueda.zoneId > 0) {
      const initialSubZones = [...subzones!]

      const filteredSubZones = initialSubZones.filter(
        (x: SubZone) => x.zoneId === busqueda.zoneId
      )

      setSubZonesByWarehouse(filteredSubZones)

      if (
        filteredSubZones.filter((x) => x.zoneId === busqueda.zoneId).length ===
        0
      ) {
        dispatch(setBusqueda({ ...busqueda, ['subzoneId']: -1 }))
      }
    } else {
      dispatch(setBusqueda({ ...busqueda, ['zoneId']: -1 }))
      dispatch(setBusqueda({ ...busqueda, ['subzoneId']: -1 }))
      setSubZonesByWarehouse([])
    }
  }

  useEffect(() => {
    handleSelectedWarehouseZones(zones!)
  }, [busqueda.warehouseId])

  useEffect(() => {
    handleSelectedSubZones(subzones!)
  }, [busqueda.zoneId])

  return (
    <Container maxWidth='xl'>
      <Paper elevation={3}>
        <div className={classes.flexContainer}>
          <div className={classes.filters}>
            <Grid container item xs={12} spacing={3}>
              <Grid item xs={6} sm={3}>
                <Selector
                  labelId='selectedWarehouse'
                  item={
                    warehouses &&
                    warehouses.map((item) => ({
                      value: item.id,
                      name: item.warehouseName
                    }))
                  }
                  defaultLabel='Almacén'
                  onChange={handleBusqueda}
                  id='warehouseId'
                  name='warehouseId'
                  value={busqueda.warehouseId}
                  variant='outlined'
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <Selector
                  labelId='selectedZone'
                  item={
                    zonesByWarehouse &&
                    zonesByWarehouse.map(({ zoneId, zoneName }: Zone) => {
                      return {
                        value: zoneId,
                        name: zoneName
                      }
                    })
                  }
                  defaultLabel='Zona'
                  onChange={handleBusqueda}
                  id='zoneId'
                  name='zoneId'
                  value={busqueda.zoneId}
                  fullWidth
                  variant='outlined'
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <Selector
                  labelId='selectedSubZone'
                  item={
                    subzonesByWarehouse &&
                    subzonesByWarehouse.map(({ id, subZoneName }: SubZone) => {
                      return {
                        value: id,
                        name: subZoneName
                      }
                    })
                  }
                  defaultLabel='SubZona'
                  onChange={handleBusqueda}
                  id='subzoneId'
                  name='subzoneId'
                  value={busqueda.subzoneId}
                  fullWidth
                  variant='outlined'
                />
              </Grid>

              <Grid item xs={6} sm={3} style={{ maxHeight: '300px' }}>
                <AutoCompleterV2
                  item={posiciones.map((item: any) => {
                    return {
                      value: item.positionName
                    }
                  })}
                  handleChangeAutoComplete={handleBusqueda}
                  isLoader={loaderName}
                  nameList={'positionName'}
                  height={0}
                  margin={0}
                  inputLabel={'Nombre Posición'}
                  value={busqueda.positionName}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TypePositionsDDL
                  onChange={handleBusqueda}
                  value={busqueda.typepositionId || -1}
                  type='outlined'
                  fullWidth
                  key={`input-typepositionId`}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <ActiveDDL
                  onChange={handleBusqueda}
                  value={busqueda.active || -1}
                  variant='outlined'
                  fullWidth
                  key={`input-active`}
                  name='active'
                />
              </Grid>
            </Grid>
          </div>
          <div className={classes.actions}>
            <span>
              {/* <IconButton color='primary' onClick={resetearBusqueda}>
                <RotateLeftIcon />
              </IconButton> */}
              <Button
                variant='contained'
                color='primary'
                onClick={fetchFilteredData}
                style={{ marginLeft: 10 }}
              >
                Buscar
              </Button>
            </span>
          </div>
        </div>
      </Paper>
    </Container>
  )
}
